import { defaultConfig, defineSemanticTokens } from '@chakra-ui/react';

const semanticShadows = defineSemanticTokens.shadows({
    ...defaultConfig.theme?.semanticTokens?.shadows,
    navMenu: {
        value: {
            _light: '0px 7px 24px {colors.gray.900/10}',
            _dark: '0px 7px 24px {colors.gray.300/30}',
        },
    },
});

export { semanticShadows };
